import {
    ADD_TO_CART,
    REMOVE_FROM_CART,
    UPDATE_CART_QUANTITY,
    CLEAR_CART,
    SET_PRODUCTS,
    SET_PAGINATION
} from "../Reducers/BuyStockReducer";

// Add product to cart
export const addToCart = (product) => ({
    type: ADD_TO_CART,
    payload: product
});

// Remove product from cart
export const removeFromCart = (productId) => ({
    type: REMOVE_FROM_CART,
    payload: productId
});

// Update cart item quantity
export const updateCartQuantity = (productId, quantity) => ({
    type: UPDATE_CART_QUANTITY,
    payload: { productId, quantity }
});

// Clear entire cart
export const clearCart = () => ({
    type: CLEAR_CART
});

// Set products list
export const setProducts = (products) => ({
    type: SET_PRODUCTS,
    payload: products
});

// Set pagination
export const setBuyStockPagination = (pagination) => ({
    type: SET_PAGINATION,
    payload: pagination
});
